import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useState, useEffect } from 'react';

export function useGroups(): {
    entities: Entity[] | undefined;
    loading: boolean;
} {
    const catalogApi = useApi(catalogApiRef);
    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState<Entity[] | undefined>(undefined);

    useEffect(() => {
        catalogApi
            .getEntities({
                filter: {
                    kind: 'group',
                },
            })
            .then(response => {
                setEntities(response.items);
                setLoading(false);
            });
    }, [catalogApi]);

    return { loading: loading, entities: entities };
}
